export default __webpack_public_path__ + "static/media/anniversary-banner-cn.895629e4.webp";